<div class="card-header">
  <div class="content">
    <h2>{{title}}</h2>
    <div class="icons">
      <button *ngIf="showReloadButton" class="icon" (click)="onRefresh()" dir="rtl">
        <app-svg-icon [icon]="IconsConstants.REFRESH_ICON"></app-svg-icon>
      </button>
      <app-filters-container *ngIf="showFiltersButton" [showSearchButton]="showFiltersSearchButton" [formGroup]="form" [searchKey]="filterSearchKey">
        <ng-content select="[filters]"></ng-content>
      </app-filters-container>
    </div>
  </div>
  <div class="header-data">
    <ng-content select="[header-data]"></ng-content>
  </div>
</div>
